<mat-sidenav-container class="layout-container">
    <!-- Sidebar -->
    <mat-sidenav class="sidebar" mode="side" opened>
        <app-sidebar />
    </mat-sidenav>

    <!-- Contenuto principale -->
    <mat-sidenav-content>
        <div class="layout-content">
            <app-header />
            <main class="page-content">
                <router-outlet />
            </main>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>